export enum SortOrder {
  ASC = 'asc',
  DESC = 'desc',
}

export interface ListSort {
  sortBy?: string;
  sortOrder?: SortOrder;
  sortName?:string
}

export interface Options {
  label: string;
  value: string;
  order: number;
}
